<template>
  <div>
    <div style="padding:10px 0 10px 10px;background: #f7f7f7;">
      {{$t('txmis.analy.dayActive')}}:<span style="color: #ff0000;font-weight: bold;font-size: 20px;">{{day.actTotal}}</span>
    </div>
    <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
      <div id="11" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="12" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="13" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
    </div>
    <div style="padding:10px 0 10px 10px;background: #f7f7f7;">
      {{$t('txmis.analy.dayReal')}}:<span style="color: #ff0000;font-weight: bold;font-size: 20px;">{{day.realTotal}}</span>
    </div>
    <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
      <div id="21" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="22" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="23" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
    </div>
    <div style="padding:10px 0 10px 10px;background: #f7f7f7;">
      {{$t('txmis.analy.dayDemo')}}:<span style="color: #ff0000;font-weight: bold;font-size: 20px;">{{day.demoTotal}}</span>
    </div>
    <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
      <div id="31" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="32" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="33" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
    </div>
    <div style="padding:10px 0 10px 10px;background: #f7f7f7;">
      {{$t('txmis.analy.dayRealDemo')}}:<span style="color: #ff0000;font-weight: bold;font-size: 20px;">{{day.realDemoTotal}}</span>
    </div>
    <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
      <div id="41" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="42" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
      <div id="43" style="height: 400px;width: 33.3333%;float:left;border-right: 1px solid #999"></div>
    </div>
  </div>
</template>

<script>
  //table封装组件
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'
  const Echarts = require('echarts');
  export default {
    name: 'index',
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.$axios.post(URL.regAct.week).then(res => {
                console.log(res);
                if (res.code != 0) return;
                let data = res.result;
                const dayResult = data[0];
                const dayResult1 = data[1];
                //计算真实+模拟的数据
                this.dataRealDemo(dayResult);
                this.dataRealDemo(dayResult1);
                this.day = dayResult;
                //渲染图一
                for (let j in this.mychart1){
                    this.setOption1(this.mychart1[j][0],this.mychart1[j][1],dayResult[this.mychart1[j][2]],dayResult[this.mychart1[j][3]],dayResult[this.mychart1[j][4]]);
                }
                //渲染图二
                this.setOption2("12",window.$t('txmis.analy.dayActive')+"("+ dayResult.actTotal +")\n"+ window.$t('txmis.analy.in')+ window.$t('txmis.analy.dayRealActive') +"("+ dayResult.actRegTotal +")",this.dataArrFormat(dayResult.acts),this.dataArrFormat(dayResult.actRegs),this.dataArrFormat(dayResult1.acts));
                for (let k in this.mychart2){
                    this.setOption3(this.mychart2[k][0],this.mychart2[k][1]+"("+dayResult[this.mychart2[k][3]]+")",this.dataArrFormat(dayResult[this.mychart2[k][2]]),this.dataArrFormat(dayResult1[this.mychart2[k][2]]));
                }
                //生成周报表需要的数据
                this.setWeekArr(data);
                //生成一周的数据
                let arr1 = [],arr2 = [],arr3 = [],arr4 = [],arr5 = [];
                for (let i=0;i<data.length;i++) {
                    arr1.push(data[i].actTotal);
                    arr2.push(data[i].actRegTotal);
                    arr3.push(data[i].realTotal);
                    arr4.push(data[i].demoTotal);
                    arr5.push(data[i].demoTotal+data[i].realTotal);
                }
                this.setOption4("13",window.$t('txmis.analy.weekActiveCount'),arr1,arr2,this.exday(arr1));
                this.setOption5("23",window.$t('txmis.analy.weekRealCount'),[window.$t('txmis.analy.realCount'),window.$t('txmis.analy.averCount')],arr3,this.exday(arr3));
                this.setOption5("33",window.$t('txmis.analy.weekDemoCount'),[window.$t('txmis.analy.demoCount'),window.$t('txmis.analy.averCount')],arr4,this.exday(arr4));
                this.setOption5("43",window.$t('txmis.analy.weekRealDemoCount'),[window.$t('txmis.analy.realDemoCount'),window.$t('txmis.analy.averCount')],arr5,this.exday(arr5));
            });
        },
        setWeekArr(data){
            const length = data.length;
            if (length < 8){
              for (let i= length;i<8;i++){
                data.push({});
              }
            }
            data.reverse();
        },
        dataRealDemo(data){
            data.realDemoApp = data.realApp + data.demoApp;
            data.realDemoLp = data.realLp + data.demoLp;
            data.realDemoOther = data.realOther + data.demoOther;
            data.realDemoTotal = data.realTotal + data.demoTotal;
            let realsDemos = {};
            const realArr = JSON.parse(data.reals);
            const demoArr = JSON.parse(data.demos);
            for (let i = 0;i < 24;i++) {
                realsDemos["h_"+i] = (realArr["h_"+i]+demoArr["h_"+i]);
            }
            data.realsDemos = JSON.stringify(realsDemos);
        },
        dataArrFormat(data){
            const parse = JSON.parse(data);
            let formatArr = [];
            for (let i = 0;i < 24;i++) {
                formatArr.push(parse["h_"+i])
            }
            return formatArr;
        },
        exday(data){
            let tmp = [];
            let need = [];
            for (let i=0;i<7;i++) {
                let day = this.beDay(7-i);
                if(day != 0 && day != 6){
                    tmp.push(data[i] || 0);
                }
            }
            for (let i in data) {
                need[i] = this.getAver(tmp);
            }
            return need;
        },
        //获取时间的前n天时间
        beDay(beforeDay){
            let date = new Date();
            date.setDate(date.getDate()-beforeDay);
            return date.getDay();
        },
        //获取数组的平均值
        getAver(arr){
            let sum = eval(arr.join("+"));
            return (sum/arr.length*100)/100;
        },
        getNeedDay(day){
            const weekDays = {0:window.$t('txmis.analy.week0'),1:window.$t('txmis.analy.week1'),2:window.$t('txmis.analy.week2'),3:window.$t('txmis.analy.week3'),4:window.$t('txmis.analy.week4'),5:window.$t('txmis.analy.week5'),6:window.$t('txmis.analy.week6')};
            let date = new Date();
            date.setDate(date.getDate()-day);
            return weekDays[date.getDay()]+"\n" + this.dataFormat(date.getTime());
        },
        dataFormat(longTypeDate) {
            let date = new Date();
            date.setTime(longTypeDate);
            return (date.getMonth() + 1) + "/" + (date.getDate());
        },
        /*渲染图一，饼状图*/
        setOption1(id,title,app,lp,other){
            Echarts.init(document.getElementById(id)).setOption({
                title : {
                    text: title,
                    x:'left'
                },
                tooltip : {
                    trigger: 'item',
                    formatter: "<br/>{b} : {c} ({d}%)"
                },
                legend: {
                    top:"30",
                    orient: 'horizontal',
                    left: 'left',
                    data: ['app','lp','other']
                },
                series : [
                    {
                        type: 'pie',
                        radius : '55%',
                        center: ['50%', '60%'],
                        //显示数据和数据所占比例
                        label: {
                            normal: {
                                show: true,
                                formatter: '{b}: {c}({d}%)',
                                color:"#000000"
                            }
                        },
                        data:[
                            {value:app, name:'app'},
                            {value:lp, name:'lp'},
                            {value:other, name:'other'}
                        ]
                    }
                ]
            });
        },
        /*24小时双柱状加折线图*/
        setOption2(id,title,data1,data2,data3){
            Echarts.init(document.getElementById(id)).setOption({
                title : {
                    text: title,
                    x:'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    top: 40,
                    left: 'left',
                    data:[window.$t('txmis.analy.today'),window.$t('txmis.analy.dayRealActive'),window.$t('txmis.analy.yesterday')]
                },
                grid:{
                    top:80
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                ],
                series: [
                    {
                        itemStyle:{
                            normal:{
                                /*color:'#4ad2ff'*/
                      }
                  },
                  name:window.$t('txmis.analy.today'),
                  type:'bar',
                  data:data1
              },
              {
                  itemStyle:{
                      normal:{
                          /* color:'#999'*/
                      }
                  },
                  name:window.$t('txmis.analy.dayRealActive'),
                  type:'bar',
                  data:data2
              },
              {
                  itemStyle:{
                      normal:{
                          /*color:'#000000'*/
                      }
                  },
                  name:window.$t('txmis.analy.yesterday'),
                  type:'line',
                  data:data3
              }
          ]
      });
        },
        //24小时单柱状加折线图
        setOption3(id,title,data1,data2){
            Echarts.init(document.getElementById(id)).setOption({
                title : {
                    text: title,
                    x:'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            /* color: '#999'*/
                        }
                    }
                },
                legend: {
                    top:30,
                    left: 'left',
                    data:[window.$t('txmis.analy.today'),window.$t('txmis.analy.yesterday')]
                },
                grid:{
                    top:60,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: ['0','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23'],
                        axisPointer: {
                            type: 'shadow'
                        }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                ],
                series: [
                    {
                        itemStyle:{
                            normal:{
                                /*color:'#4ad2ff'*/
                            }
                        },
                        name:window.$t('txmis.analy.today'),
                        type:'bar',
                        data:data1
                    },
                    {
                        itemStyle:{
                            normal:{
                                /* color:'#4ad2ff'*/
                            }
                        },
                        name:window.$t('txmis.analy.yesterday'),
                        type:'line',
                        data:data2
                    }
                ]
            });
        },
        setOption4(id,title,data1,data2,data3){
            const data = data1.slice(0,data1.length-1);
            const option = {value:data1[data1.length-1],itemStyle:{color:"#c33430"}};
            data.push(option);
            const weekArr = [this.getNeedDay(7),this.getNeedDay(6),this.getNeedDay(5),this.getNeedDay(4),this.getNeedDay(3),this.getNeedDay(2),this.getNeedDay(1),this.getNeedDay(0)];
            Echarts.init(document.getElementById(id)).setOption({
                title : {
                    text: title,
                    x:'left',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    top:30,
                    left: 'left',
                    data:[window.$t('txmis.analy.activeCount'),window.$t('txmis.analy.dayRealActive'),window.$t('txmis.analy.averCount')]
                },
                grid:{
                    top:90,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: weekArr,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel:{
                            interval:0,
                            rotate:45,
                            margin:10,
                            textStyle:{
                                color:"#222"
                            }}
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                ],
                series: [
                    {
                        itemStyle:{
                            normal:{
                                /*color:'#4ad2ff'*/
                            }
                        },
                        name:window.$t('txmis.analy.activeCount'),
                        type:'bar',
                        data:data
                    },
                    {
                        itemStyle:{
                            normal:{
                                /*color:'#4ad2ff'*/
                            }
                        },
                        name:window.$t('txmis.analy.dayRealActive'),
                        type:'bar',
                        data:data2
                    },
                    {
                        itemStyle:{
                            normal:{
                                /*color:'#4ad2ff'*/
                            }
                        },
                        name:window.$t('txmis.analy.averCount'),
                        type:'line',
                        data:data3
                    }
                ]
            });
        },
        setOption5(id,title,names,data1,data2){
            let data = data1.slice(0,data1.length-1);
            let option = {value:data1[data1.length-1],itemStyle:{color:"#c33430"}};
            data.push(option);
            const weekArr = [this.getNeedDay(7),this.getNeedDay(6),this.getNeedDay(5),this.getNeedDay(4),this.getNeedDay(3),this.getNeedDay(2),this.getNeedDay(1),this.getNeedDay(0)];
            Echarts.init(document.getElementById(id)).setOption({
                title : {
                    text: title,
                    x:'left'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    top:30,
                    left: 'left',
                    data:names
                },
                grid:{
                    top:60,
                },
                xAxis: [
                    {
                        type: 'category',
                        data: weekArr,
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel:{ interval:0,
                            rotate:45,
                            margin:10,
                            textStyle:{
                                color:"#222"
                            }}
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}'
                        }
                    },
                ],
                series: [
                    {
                        itemStyle:{
                            normal:{
                                /*color:'#4ad2ff'*/
                            }
                        },
                        name:names[0],
                        type:'bar',
                        data:data
                    },
                    {
                        itemStyle:{
                            normal:{
                                /* color:'#4ad2ff'*/
                            }
                        },
                        name:names[1],
                        type:'line',
                        data:data2
                    }
                ]
            });
        }
    },
    data () {
      return {
          day:{},
          /*图一数据工具类，饼状图*/
          mychart1:[
              ["11",window.$t('txmis.analy.dayActiveRate'),"actApp","actLp","actOther"],
              ["21",window.$t('txmis.analy.dayRealRate'),"realApp","realLp","realOther"],
              ["31",window.$t('txmis.analy.dayDemoRate'),"demoApp","demoLp","demoOther"],
              ["41",window.$t('txmis.analy.dayRealDemoRate'),"realDemoApp","realDemoLp","realDemoOther"],
          ],
          mychart2:[
              ["22",window.$t('txmis.analy.dayRealCount'),"reals","realTotal"],
              ["32",window.$t('txmis.analy.dayDemoCount'),"demos","demoTotal"],
              ["42",window.$t('txmis.analy.dayRealDemoCount'),"realsDemos","realDemoTotal"],
          ]
      }
    }
  }
</script>
